import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbCatalogApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbCatalog';
    }

    /**
     * 获取全部数据
     */
    public async getListAll() {
        return await this.send({}, 'getListAll', Methods.GET);
    }
    /**
     * 获取全部数据
     */
    public async getListAllByUserId(userId) {
        return await this.send({userId:userId}, 'getListAllByUserId', Methods.GET);
    }

    public async dbCatalogSaveOrUpdate(datas) {
        return await this.send(datas, 'dbCatalogSaveOrUpdate', Methods.POST);
    }

}